import * as React from 'react';

export type EmbeddedHtmlProps = {
    className?: string;
    disableInteraction?: boolean;
    html: string;
};

const domParser = new DOMParser();

/**
 * This function adds a script to the html document preventing
 * Clicking on any element with an ng-href or href attribute
 *
 * @param template - The html document as a string
 * @returns The html document with embedded script
 */
function addLinkPreventionScriptToTemplate(template: string): string {
    const doc = domParser.parseFromString(template, 'text/html');
    const script = doc.createElement('script');
    script.textContent = `
        window.addEventListener('load', function () {
            var linkElements = document.querySelectorAll('[ng-href],[href]');
            for (var i = 0; i < linkElements.length; i++) {
                var link = linkElements[i];
                link.addEventListener('click', function (event) {
                    event.preventDefault();
                });
            }
        });
    `;
    doc.body.appendChild(script);
    return doc.documentElement.outerHTML;
}

export const EmbeddedHtml: React.FunctionComponent<EmbeddedHtmlProps> = props => {
    const { className, disableInteraction = true, html } = props;

    const htmlBlob = React.useMemo(() => {
        let htmlString = html;
        if (disableInteraction) {
            htmlString = addLinkPreventionScriptToTemplate(htmlString);
        }
        return htmlString;
    }, [html, disableInteraction]);

    return (
        <iframe
                className={className}
                sandbox={disableInteraction ? 'allow-scripts' : undefined}
                srcDoc={htmlBlob}
            />
    );
};

EmbeddedHtml.displayName = 'EmbeddedHtml';
